import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';

import DashedLineIcon from '@/assets/icons/dashed-line.svg?react';
import SeparatedList from '@/components/SeparatedList';
import { borders } from '@/theme/constants';
import typography from '@/theme/typography';

interface HorizontalStepperProps {
  labels: string[];
  value: number;
}

const HorizontalStepper = ({ labels, value }: HorizontalStepperProps) => (
  <SeparatedList
    separator={
      <Stack mx={1}>
        <DashedLineIcon />
      </Stack>
    }
    alignItems="center"
  >
    {labels.map((label, index) => (
      <Stack direction="row" key={index} alignItems="center" gap={1}>
        <Box
          sx={mergeSx(
            {
              width: 22,
              height: 22,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            index < value && { backgroundColor: 'primary.900' },
            index === value && { border: borders.default, borderColor: 'primary.900' },
            index > value && { border: borders.default, borderColor: 'grey.600' }
          )}
        >
          <Box
            sx={mergeSx(
              {
                width: 18,
                height: 18,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              index === value && { backgroundColor: 'primary.900' }
            )}
          >
            <Typography
              variant="body3"
              sx={mergeSx(
                { fontWeight: typography.fontWeightMedium },
                index <= value && { color: 'white' },
                index > value && { color: 'grey.600' }
              )}
            >
              {index + 1}
            </Typography>
          </Box>
        </Box>
        <Typography
          variant="body3"
          sx={mergeSx(
            index === value && { color: 'primary.main', fontWeight: typography.fontWeightMedium },
            index > value && { color: 'grey.600' }
          )}
        >
          {label}
        </Typography>
      </Stack>
    ))}
  </SeparatedList>
);

export default HorizontalStepper;
